// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3916":"825aa555","5797":"f287e0ee"}[chunkId] + ".chunk.css";
};